module.exports = __webpack_public_path__ + "static/fonts/big-monster.svg";